const firebaseConfig = {
   apiKey: process.env.FIREBASE_API_KEY,
   authDomain: "nomenclaturas-e801d.firebaseapp.com",
   projectId: "nomenclaturas-e801d",
   storageBucket: "nomenclaturas-e801d.appspot.com",
   messagingSenderId: "165480877931",
   appId: "1:165480877931:web:a72164ce65d33cd4fb062e",
}

export default firebaseConfig
